import { render, staticRenderFns } from "./UserBasic.vue?vue&type=template&id=472236e8"
import script from "./UserBasic.vue?vue&type=script&lang=js"
export * from "./UserBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports